import Security from '@/config/security';
import { ns } from '@/helpers/store';
import { ACCEPT_INVITES, ADD_ACCOUNT, FETCH_ACCOUNTS, FETCH_USER, RESTORE_ACCOUNT, SET_LEGACY_ACCOUNT, SUDO_SET_ACCOUNT } from '@/store/types/actions';
import { ACCOUNTS_FETCHED, ACCOUNT_ADDED, ACCOUNT_RESTORED, ACCOUNT_SELECTED, LEGACY_TOKEN_FETCHED } from '@/store/types/mutations';
import { AUTH } from '@/store/types/namespaces';
import { apolloSdk } from '../../api/apollo';

export const ACCOUNT_KEY = 'dp.account';
export const SUDO_PREFIX = 'dp.sudo';

const actions = {
  async [ACCEPT_INVITES]() {
    await apolloSdk.AcceptInvites();
  },
  async [FETCH_ACCOUNTS]({ commit }) {
    const response = await apolloSdk.Accounts();
    commit(ACCOUNTS_FETCHED, response.accounts);
  },
  async [ADD_ACCOUNT]({ commit }, { name }) {
    const response = await apolloSdk.AddAccount({ input: { name } });
    const { account, errors } = response.addAccount;
    if (errors) {
      return Promise.reject(errors);
    }
    commit(ACCOUNT_ADDED, account);
    return account;
  },
  async [SET_LEGACY_ACCOUNT]({ commit, dispatch }, account) {
    const { id } = account;

    commit(ACCOUNT_SELECTED, account);
    const response = await apolloSdk.LegacyToken({ accountId: id });
    commit(LEGACY_TOKEN_FETCHED, response.legacyToken.token);
    const { node: { role } } = await apolloSdk.AccountRole({ accountId: id });
    Security.setCurrentUser(role);
    dispatch(ns(AUTH, FETCH_USER), null, { root: true });
  },
  async [SUDO_SET_ACCOUNT]({ state, dispatch }, nodeIdOrAlias) {
    let nodeId;
    if (nodeIdOrAlias.startsWith('acc_')) {
      nodeId = nodeIdOrAlias;
    } else if (nodeIdOrAlias.includes('=acc_')) {
      const [alias, id] = nodeIdOrAlias.split('=');
      nodeId = id;
      window.localStorage.setItem(`${SUDO_PREFIX}.${alias}`, nodeId);
    } else {
      nodeId = window.localStorage.getItem(`${SUDO_PREFIX}.${nodeIdOrAlias}`);
    }
    if (!nodeId) {
      throw new Error('Alias not found');
    }
    if (state.accounts.some(({ id }) => id === nodeId)) {
      return dispatch(SET_LEGACY_ACCOUNT, { id: nodeId });
    }
    await apolloSdk.SudoGetTemporaryRole({ nodeId });
    return dispatch(SET_LEGACY_ACCOUNT, { id: nodeId });
  },
  async [RESTORE_ACCOUNT]({ commit }) {
    const id = window.localStorage.getItem(ACCOUNT_KEY);
    if (id) {
      commit(ACCOUNT_RESTORED, id);
    }
  },
};

const mutations = {
  [ACCOUNTS_FETCHED](state, accounts) {
    state.accounts = accounts;
  },
  [ACCOUNT_ADDED](state, account) {
    state.accounts.push(account);
  },
  [LEGACY_TOKEN_FETCHED](state, token) {
    state.legacyToken = token;
  },
  [ACCOUNT_SELECTED](state, account) {
    window.localStorage.setItem(ACCOUNT_KEY, account.id);
    state.currentAccount = account;
  },
  [ACCOUNT_RESTORED](state, id) {
    state.currentAccount = {
      id,
    };
  },
};

const state = {
  accounts: [],
  legacyToken: null,
  currentAccount: null,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
